export default __webpack_public_path__ + "img/2708edcb7500e405950c3653b2415c53.svg";